/* Click-ID capture voor Google Ads offline conversie-import */
(function() {
  'use strict';

  var COOKIE_DAYS = 90;
  var COOKIE_PREFIX = '_gcw_';
  var CLICK_IDS = ['gclid', 'gbraid', 'wbraid'];

  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      var domain = location.hostname.replace(/^www\./, '');
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() +
        ';path=/;domain=.' + domain +
        ';SameSite=Lax' +
        (location.protocol === 'https:' ? ';Secure' : '');
    } catch(e) {}
  }

  function getCookie(name) {
    try {
      var v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
      return v ? decodeURIComponent(v[2]) : null;
    } catch(e) { return null; }
  }

  function getParam(name) {
    try {
      var s = window.location.search;
      if (!s) return null;
      var m = s.match(new RegExp('[?&]' + name + '=([^&#]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch(e) { return null; }
  }

  var captured = null;
  var capturedType = null;
  for (var i = 0; i < CLICK_IDS.length; i++) {
    var id = CLICK_IDS[i];
    var val = getParam(id);
    if (val) {
      captured = val;
      capturedType = id;
      setCookie(COOKIE_PREFIX + id, val, COOKIE_DAYS);
      setCookie(COOKIE_PREFIX + 'ts', Date.now().toString(), COOKIE_DAYS);
      setCookie(COOKIE_PREFIX + 'type', id, COOKIE_DAYS);
      setCookie(COOKIE_PREFIX + 'landing', window.location.href.substring(0, 500), COOKIE_DAYS);
      break;
    }
  }

  var storedType = getCookie(COOKIE_PREFIX + 'type');
  var storedVal = storedType ? getCookie(COOKIE_PREFIX + storedType) : null;
  var storedTs = getCookie(COOKIE_PREFIX + 'ts');
  var storedLanding = getCookie(COOKIE_PREFIX + 'landing');

  if (!storedType || !storedVal) {
    return;
  }

  function updateCartAttributes() {
    try {
      var payload = { attributes: {} };
      payload.attributes[storedType] = storedVal;
      if (storedTs) payload.attributes['_gcw_ts'] = storedTs;
      if (storedLanding) payload.attributes['_gcw_landing'] = storedLanding;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin',
        keepalive: true
      }).catch(function() {});
    } catch(e) {}
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(updateCartAttributes, 800);
  } else {
    window.addEventListener('DOMContentLoaded', function() {
      setTimeout(updateCartAttributes, 800);
    });
  }

  window._gcwDebug = function() {
    return {
      type: storedType,
      value: storedVal,
      timestamp: storedTs ? new Date(parseInt(storedTs, 10)).toISOString() : null,
      landing: storedLanding,
      just_captured: !!captured,
      cookies_present: {
        gclid: !!getCookie(COOKIE_PREFIX + 'gclid'),
        gbraid: !!getCookie(COOKIE_PREFIX + 'gbraid'),
        wbraid: !!getCookie(COOKIE_PREFIX + 'wbraid')
      }
    };
  };
})();
